import { Component, Input, OnInit } from '@angular/core';
import { Student } from '../../models/student.model';

@Component({
    selector: 'app-student-detail',
    templateUrl: './student-detail.component.html',
    styleUrls: ['./student-detail.component.scss']
})
export class StudentDetailComponent implements OnInit {

    @Input() student: Student;

    constructor() { }

    ngOnInit() { }

}
